import { render, staticRenderFns } from "./Algorithms.vue?vue&type=template&id=3f11f9f4"
import script from "./Algorithms.vue?vue&type=script&lang=js"
export * from "./Algorithms.vue?vue&type=script&lang=js"
import style0 from "./Algorithms.vue?vue&type=style&index=0&id=3f11f9f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports